import React, { useState } from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

export const STAGE_PROGRESS_NOTE =
  "Recorded stage is the deal's current step on its journey, including Management Pack and BSA on leasehold deals. Milestones completed counts key stages that are fully done, so it trails the current step while that step is in progress.";

// Info icon explaining "Recorded stage" vs "Milestones completed"; opens on hover, focus or tap.
export const StageProgressHint = ({ testid }) => {
  const [open, setOpen] = useState(false);
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="What do Recorded stage and Milestones completed mean?"
            className="inline-flex items-center justify-center h-4 w-4 align-middle text-slate-400 hover:text-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-300 rounded-full"
            data-testid={testid}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((v) => !v); }}
          >
            <Info size={12} />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="max-w-[260px] bg-slate-900 text-white text-[11.5px] leading-snug"
          data-testid={`${testid}-content`}
          onPointerDownOutside={() => setOpen(false)}
        >
          {STAGE_PROGRESS_NOTE}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
